// AboutPage.js
import React from 'react';

const AboutPage = () => {
  return (
    <div>
      <h1>About Us</h1>
      <p>We are a company dedicated to providing high-quality products to our customers.</p>
    </div>
  );
}

export default AboutPage;
